import bootConfig from './bootConfig';

export function isFeatureEnabled(flagName: string): boolean {
  return Boolean(bootConfig.authInfo?.featureFlags?.[flagName]);
}

// Constants for feature flag names to avoid typos
export const FEATURE_FLAGS = {
  BULK_LINK_EXPORT: 'f980759_LTI13_Bulk_Export_From_Link_Manager',
};
